<template>
	<div class="Login">
		<van-nav-bar title="授权成功" fixed bord>
		</van-nav-bar>

		<div class="login-img">
			<img src="../assets/logo.png" width="100" height="100" alt />
		</div>
	
		<div class="login-wechat">
			授权完成，即将跳转...
		</div>
	</div>
</template>
<script>

export default {
	name: "Login",
	components: {
	},
	data() {
		return {
		};
	},
	created(){
		const qrys = this.$route.query;
		this.getUserInfo(qrys.code);
	},
	methods: {
		getUserInfo(code){
			var url = this.Conf.serverUrl + "Common/wxAuthCall" + "?num=" + Math.random();
			var data = {
				code: code
			};
		  	let that = this;
			this.$axios.post(url, this.$qs.stringify(data))
            .then(response => {
				data = response.data;
				switch (data.code) {
					case 200:
						that.$toast.success(data.msg);
						// 保存服务端返回的token、用户id
						localStorage.setItem(
							data.u_id + "token",
							data.token
						);
						localStorage.setItem("u_id", data.u_id);
						if (data.userInfo) {
							localStorage.setItem( "userInfo", JSON.stringify(data.userInfo) );
						}
						// 绑定通讯用户信息
						if ((that.websocket && that.websocket.ws && that.websocket.ws.readyState == 1) ) {
							that.websocket.ws.send(JSON.stringify({
								mk:200,
								uid:data.u_id,
								token:data.token,
								rndid:that.$store.state.common.rndid
							}));
						}
						localStorage.removeItem("inviter_code");
						// 登录成功跳转到首页
						if(that.prePath){
							localStorage.removeItem("before_path");
							that.$router.push({ path: prePath });
						}else{
							that.$router.push({ path: this.Conf.homeUrl });
						}
						break;
					case 40001:
						that.$toast.fail(data.msg);
						that.$router.push({ path: "/Login" });
						break;
				  }
            })
            .catch(error => {
            });
		}
	},
	mounted() {
	},
};
</script>



// WEBPACK FOOTER //
// src/components/AuthCall.vue